module.exports = __webpack_public_path__ + "static/img/1-15.b8e6754.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/1-15.png
// module id = rbf8
// module chunks = 15